import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../assist/src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AssistAuthService {
  constructor(private oauthService: OAuthService) { }


  /** Start de login via Authorization Code Flow met PKCE */
  login(returnUrl: string = "", organizationKey?: string): void {
    sessionStorage.setItem('returnUrl', returnUrl ?? window.location.pathname);
    this.oauthService.initCodeFlow('', organizationKey ? { organizationKey } : {});
  }

  /** Logt de gebruiker uit */
  logout(): void {
    this.oauthService.logOut();

    // Redirect naar auth server logout met return URL
    const returnUrl = encodeURIComponent(window.location.origin);
    window.location.replace(
      `${environment.authenticationServer}Account/logout?returnUrl=${returnUrl}`
    );
  }

  /** Synchronous controle: is de gebruiker ingelogd? */
  get isLoggedIn(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  /** Observable die emit wanneer de loginstatus verandert */
  get isLoggedIn$(): Observable<boolean> {
    return this.oauthService.events.pipe(
      filter((e) => [
        'token_received',
        'session_terminated',
        'session_error'
      ].includes(e.type)),
      startWith(this.oauthService.hasValidAccessToken()),
      map(() => this.oauthService.hasValidAccessToken())
    );
  }

  /** Geeft het access token (indien beschikbaar) */
  get accessToken(): string | null {
    return this.oauthService.getAccessToken();
  }

  /** Geeft claims uit de ID-token (indien aanwezig) */
  get identityClaims(): any {
    return this.oauthService.getIdentityClaims();
  }

  /** ID van de ingelogde gebruiker (subject claim) */
  get userId(): string | undefined {
    const claims = this.identityClaims;
    console.log("claims", claims);
    return claims?.sub;
  }
 
}
